"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transition = exports.NotificationTransition = exports.limit = exports.getRoot = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var BaseTransition_1 = require("../transition/BaseTransition");
var hash_object_1 = require("../_util/hash-object");
var insert_css_1 = require("../_util/insert-css");
var rootId = "tea-notification-root";
function getRoot(classPrefix) {
    var root = window[rootId] || document.getElementById(rootId);
    if (!root) {
        root = document.createElement("div");
        root.id = rootId;
        root.className = classPrefix + "-notification-wrap";
        document.body.appendChild(root);
        window[rootId] = root;
    }
    return root;
}
exports.getRoot = getRoot;
var maxCountLimit = 3;
var listKey = "tea-notification-list-identification";
function limit(notice) {
    if (!window[listKey]) {
        window[listKey] = [];
    }
    if (notice.identifier) {
        var existedItem = window[listKey].find(function (i) { return i.isExisted && i.isExisted() && i.identifier === notice.identifier; });
        // 存在相同内容，续期原内容
        if (existedItem) {
            existedItem.renew();
            return;
        }
        notice.show();
    }
    else {
        notice.show();
    }
    if (window[listKey].length >= maxCountLimit) {
        try {
            window[listKey][0].hide();
            window[listKey].shift();
        }
        catch (_) {
            // hide failed
        }
    }
    window[listKey].push(notice);
}
exports.limit = limit;
function NotificationTransition(props) {
    return react_1.default.createElement(BaseTransition_1.BaseTransition, tslib_1.__assign({}, transition(), props));
}
exports.NotificationTransition = NotificationTransition;
var generateCSS = function (transition, targetMaxHeight) { return "\n." + transition.classNames + "-enter {\n  opacity: 0 !important;\n  transform: translate3d(60px, 0px, 0);\n}\n." + transition.classNames + "-enter-active {\n  opacity: 1 !important;\n  transform: translate3d(0, 0, 0);\n  transition: opacity " + transition.timeout.enter + "ms ease,\n    transform " + transition.timeout.enter + "ms ease;\n}\n." + transition.classNames + "-exit {\n    opacity: 1;\n    max-height: " + targetMaxHeight + "px;\n    margin-bottom: 20px;\n}\n." + transition.classNames + "-exit-active {\n    max-height: 0;\n    margin-bottom: 0 !important;\n    opacity: 0;\n    transition: max-height " + transition.timeout.exit + "ms ease,\n      margin-bottom " + transition.timeout.exit + "ms ease,\n      opacity " + transition.timeout.enter + "ms ease;\n}\n"; };
var setupTransitions = {};
function transition(targetHeight, enterTimeout, leaveTimeout) {
    if (targetHeight === void 0) { targetHeight = 150; }
    if (enterTimeout === void 0) { enterTimeout = 300; }
    if (leaveTimeout === void 0) { leaveTimeout = 300; }
    var name = "tea-transition-notification";
    var hash = hash_object_1.hashObject({ name: name, targetHeight: targetHeight, enterTimeout: enterTimeout, leaveTimeout: leaveTimeout });
    if (!setupTransitions[hash]) {
        setupTransitions[hash] = {
            classNames: name + hash,
            timeout: {
                enter: enterTimeout,
                exit: leaveTimeout,
            },
            unmountOnExit: true,
            mountOnEnter: true,
        };
        var transition_1 = setupTransitions[hash];
        var css = generateCSS(transition_1, targetHeight);
        insert_css_1.insertCSS(name + hash, css);
    }
    return setupTransitions[hash];
}
exports.transition = transition;
//# sourceMappingURL=util.js.map